import React from 'react';
import { useLocation } from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import useStudio from './hooks/useStudio';
import StudioView from './view';
import ArtTemplateGenerator from './screens/ArtTemplateGenerator';
import { STUDIO_ART_TEMPLATE_GENERATOR } from './enums/routes';

// The template generator stands alone: no session, no Studio API (useStudio is never mounted).
export default function Studio() {
  const { pathname } = useLocation();
  const generator = pathname.replace(/\/+$/, '') === STUDIO_ART_TEMPLATE_GENERATOR;
  return <MotionConfig reducedMotion="user" transition={{ duration: 0.2, ease: 'easeOut' }}>{generator ? <ArtTemplateGenerator /> : <StudioApp />}</MotionConfig>;
}

function StudioApp() {
  const studio = useStudio();
  return <StudioView studio={studio} />;
}
